import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
    const [site, setSite] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/site");
            setSite(data);
        } catch {
            /* keep null */
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <SiteContext.Provider value={{ site, loading, refresh: load, setSite }}>
            {children}
        </SiteContext.Provider>
    );
}

export function useSite() {
    const ctx = useContext(SiteContext);
    if (!ctx) throw new Error("useSite must be used within SiteProvider");
    return ctx;
}

// Keep the browser tab title in sync with the configured company name.
const BASE_TITLE = "Agence Immobilière au Mali";
export function SiteDocumentTitle() {
    const { site } = useSite();
    useEffect(() => {
        const name = site?.identity?.name_fr || "GAB'S SERVICES";
        document.title = `${name} — ${BASE_TITLE}`;
    }, [site]);
    return null;
}

// Convenience helpers — return sane fallbacks
export function siteText(site, key, lang, fallback = "") {
    if (!site) return fallback;
    const parts = key.split(".");
    let cur = site;
    for (const p of parts) cur = cur?.[p];
    if (cur == null) return fallback;
    if (typeof cur === "object" && !Array.isArray(cur)) {
        return cur[lang] || cur.fr || cur.en || fallback;
    }
    return cur;
}

export function waLink(number, text = "") {
    if (!number) return "#";
    const base = `https://wa.me/${String(number).replace(/[^0-9]/g, "")}`;
    if (!text) return base;
    return `${base}?text=${encodeURIComponent(text)}`;
}
